import { useMemo } from 'react';
import { normaliseSite, getFeatureColor } from '../utils/siteStatus';

// Match a site against the selected titles.
// A site matches if any of its activity titles (_titles array) is selected.
// Falls back to _title (dominant) for sites without _titles populated.
function siteMatchesTitles(site, selectedTitles) {
	if (!selectedTitles || selectedTitles.length === 0) return true;
	if (site._titles && site._titles.length > 0) {
		return site._titles.some((t) => selectedTitles.includes(t));
	}
	if (site._title) return selectedTitles.includes(site._title);
	return false;
}

export function useVisibleSites(sites, filters, hideInactive) {
	const colouredSites = useMemo(function() {
		return sites.map(function(site) {
			return normaliseSite(site, filters.startDate, filters.endDate, filters.activityStatus);
		});
	}, [sites, filters.startDate, filters.endDate, filters.activityStatus]);

	const selectedTitles = filters.selectedTitles || [];

	const visibleSites = useMemo(function() {
		return colouredSites.filter(function(s) {
			if (hideInactive && s._status === 'none') return false;
			if (hideInactive && selectedTitles.length > 0
			    && s._status !== 'none' && !siteMatchesTitles(s, selectedTitles)) return false;
			return true;
		});
	}, [colouredSites, hideInactive, selectedTitles]);

	// Stats — when a title filter is active, only count active sites that match.
	// Inactive (none) sites are counted regardless of the title filter.
	const stats = useMemo(function() {
		var c = { inprogress: 0, planned: 0, none: 0, overdue: 0 };
		visibleSites.forEach(function(s) {
			if (s._status === 'none') {
				c.none++;
				return;
			}
			if (selectedTitles.length > 0 && !siteMatchesTitles(s, selectedTitles)) return;
			if (s._status === 'overdue') c.overdue++;
			else c[s._status] = (c[s._status] || 0) + 1;
		});
		return c;
	}, [visibleSites, selectedTitles]);

	// featureStats — also respects the title filter
	const featureStats = useMemo(function() {
		var result = {};
		colouredSites.forEach(function(s) {
			if (s._status === 'none' || !s._feature) return;
			if (selectedTitles.length > 0 && !siteMatchesTitles(s, selectedTitles)) return;
			if (!result[s._feature]) {
				result[s._feature] = { color: getFeatureColor(s._feature), count: 0 };
			}
			result[s._feature].count++;
		});
		return result;
	}, [colouredSites, selectedTitles]);

	return { colouredSites, visibleSites, featureStats, stats };
}